const LOCATIONS_SMALL = [
    "brandbu",
    "brattvåg",
    "bremanger",
    "brønnøysund",
    "bø i vesterålen",
    "dokka", "drangedal",
    "eid",
    "eidsvoll",
    "fagernes",
    "fauske",
    "finnsnes",
    "fitjar",
    "flisa",
    "florø",
    "folldal",
    "frøya",
    "geilo",
    "gloppen",
    "grong",
    "heggelia",
    "hitra",
    "hov",
    "husnes",
    "høyanger",
    "kjøllefjord i lebesby",
    "kolbotn",
    "kolvereid",
    "kragerø",
    "lakselv",
    "lillesand",
    "longyearbyen",
    "melhus",
    "mysen",
    "måløy",
    "nordkapp",
    "norheimsund",
    "odda",
    "orkdal",
    "otta",
    "rakkestad",
    "rjukan",
    "rødberg",
    "sauda",
    "setermoen",
    "sirdal",
    "skjervøy",
    "skjold",
    "sokndal",
    "sortland",
    "stokmarknes",
    "stor-elvdal",
    "storslett",
    "strand",
    "stranda",
    "stryn",
    "støren",
    "suldal",
    "surnadal",
    "svolvær",
    "sykkylven",
    "tana",
    "tromsø",
    "trysil",
    "ulefoss",
    "ulvik",
    "vardø",
    "vikersund",
    "vinstra",
    "volda",
    "vågå",
    "åmot",
    "åndalsnes",
    "årdal",
    "ås"
];
export { LOCATIONS_SMALL }